<div class="tubelight-navbar" [class.hidden-nav]="isHidden">
  <div class="navbar-container">
    <!-- Left Nav Items -->
    <div class="nav-group nav-left">
      <a *ngFor="let item of leftNavItems" [href]="item.url" (click)="setActiveTab(item.name, $event)" class="nav-item"
        [class.active]="activeTab === item.name">
        <span class="nav-text d-none d-md-inline">{{ item.name }}</span>
        <span class="nav-icon d-md-none">
          <i [class]="item.icon"></i>
        </span>
        <div *ngIf="activeTab === item.name" class="lamp-effect">
          <div class="lamp-base">
            <div class="lamp-light"></div>
            <div class="lamp-glow-top"></div>
            <div class="lamp-glow-bottom"></div>
          </div>
        </div>
      </a>
    </div>

    <!-- Diamond Center with Heart Logo -->
    <div class="diamond-center" role="button" tabindex="0" (click)="goHome($event)" (keydown.enter)="goHome($event)">
      <div class="diamond-shape">
        <img class="heart-logo" src="assets/images/logo-384.webp" width="384" height="384"
          alt="Logotipo del Consultorio Bien-Estar: corazón con flores">
      </div>
    </div>

    <!-- Right Nav Items -->
    <div class="nav-group nav-right">
      <a *ngFor="let item of rightNavItems" [href]="item.url" (click)="setActiveTab(item.name, $event)" class="nav-item"
        [class.active]="activeTab === item.name">
        <span class="nav-text d-none d-md-inline">{{ item.name }}</span>
        <span class="nav-icon d-md-none">
          <i [class]="item.icon"></i>
        </span>
        <div *ngIf="activeTab === item.name" class="lamp-effect">
          <div class="lamp-base">
            <div class="lamp-light"></div>
            <div class="lamp-glow-top"></div>
            <div class="lamp-glow-bottom"></div>
          </div>
        </div>
      </a>
    </div>
  </div>
</div>

<!-- Header para celular: barra completa con el logo centrado sobre el mismo
     rombo del menú de escritorio y menú desplegable a la derecha.
     Solo se muestra por debajo de 768px (ver header-top.component.css). -->
<header class="mobile-header" [class.hidden-nav]="isHidden && !menuOpen" [class.menu-open]="menuOpen">
  <div class="mobile-bar">
    <a class="mobile-brand" href="#" (click)="goHome($event)">
      <span class="mobile-diamond" aria-hidden="true"></span>
      <img class="mobile-logo" src="assets/images/logo-384.webp" width="384" height="384"
        alt="Logotipo del Consultorio Bien-Estar: corazón con flores">
    </a>

    <button type="button" class="mobile-toggle" (click)="toggleMenu()"
      [attr.aria-expanded]="menuOpen" aria-controls="mobile-menu"
      [attr.aria-label]="menuOpen ? 'Cerrar menú' : 'Abrir menú'">
      <span class="mobile-toggle-line"></span>
      <span class="mobile-toggle-line"></span>
      <span class="mobile-toggle-line"></span>
    </button>
  </div>

  <nav class="mobile-menu" id="mobile-menu" aria-label="Secciones" [attr.aria-hidden]="!menuOpen">
    <ul class="mobile-menu-list">
      <li *ngFor="let item of navItems">
        <a [href]="item.url" (click)="setActiveTab(item.name, $event)" class="mobile-menu-item"
          [class.active]="activeTab === item.name" [attr.aria-current]="activeTab === item.name ? 'true' : null"
          [attr.tabindex]="menuOpen ? null : -1">
          <i [class]="item.icon" aria-hidden="true"></i>
          <span>{{ item.name }}</span>
        </a>
      </li>
    </ul>
  </nav>
</header>

<!-- Velo para cerrar el menú tocando fuera -->
<div class="mobile-backdrop" *ngIf="menuOpen" (click)="closeMenu()" aria-hidden="true"></div>